import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksVendorFields.ContactPersonsSection', {
    header: 'CONTACT PERSON',
    displayName: 'Display name',
    companyName: 'Company',
    contact: 'Contact',
});
